import { render, staticRenderFns } from "./UsersTitle.vue?vue&type=template&id=a5432780&scoped=true"
import script from "./UsersTitle.vue?vue&type=script&lang=js"
export * from "./UsersTitle.vue?vue&type=script&lang=js"
import style0 from "./UsersTitle.vue?vue&type=style&index=0&id=a5432780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5432780",
  null
  
)

export default component.exports